import { Badge, type BadgeProps } from './Badge.tsx'
import {
  resolveStatusLabel,
  resolveStatusVariant,
  type BadgeVariant,
} from '@/styles/tokens.ts'

interface StatusBadgeProps extends Omit<BadgeProps, 'variant' | 'children'> {
  /** Roh-Status aus der API (z.B. `"in_progress"`, `"Overdue"`, oder eine numerische ID). */
  status: string | number | null | undefined
  /** Ueberschreibt das automatische Label. */
  label?: string
  /** Ueberschreibt die automatische Variante. */
  variant?: BadgeVariant
}

/**
 * Badge fuer Status-Werte (Tickets, Invoices, Orders, ...).
 * Nimmt den Rohstatus und mappt via `STATUS_VARIANTS` / `STATUS_LABELS` aus
 * `styles/tokens.ts`. Unbekannte Status → `neutral` + Original-String.
 */
export function StatusBadge({ status, label, variant, ...props }: StatusBadgeProps) {
  return (
    <Badge variant={variant ?? resolveStatusVariant(status)} {...props}>
      {label ?? resolveStatusLabel(status)}
    </Badge>
  )
}
